export class UpdateCustomerRequest {
  id?: number;
  companyId?: number;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;

  constructor(model: UpdateCustomerRequest) {
    this.id = model.id || 0;
    this.companyId = model.companyId || 0;
    this.firstName = model.firstName || '';
    this.lastName = model.lastName || '';
    this.phoneNumber = model.phoneNumber || '';
    this.email = model.email || '';
  }
}
